import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ScriptureCardProps {
  verse: string;
  reference: string;
  theme: string;
}

const ScriptureCard = ({ verse, reference, theme }: ScriptureCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-sacred-md border border-border hover:shadow-sacred-lg transition-all duration-300">
      <div className="flex items-start space-x-3 mb-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="BookOpenIcon" size={20} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-playfair text-lg font-semibold text-foreground mb-1">
            {theme}
          </h3>
          <p className="font-inter text-xs text-muted-foreground">{reference}</p>
        </div>
      </div>
      <blockquote className="font-inter text-base text-foreground leading-relaxed italic border-l-4 border-primary pl-4">
        "{verse}"
      </blockquote>
    </div>
  );
};

export default ScriptureCard;